import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteUser } from '../Api'

export default generateApiAction({
  baseType: Types.USERS.DELETE,
  api: deleteUser,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/users/DeleteAction.js